import React, {ReactElement, useContext, useEffect, useState, Fragment} from 'react'
import {
  Table,
  TableHead,
  TableBody,
  PanelHeader,
  Panel,
  InfoText,
  PanelFooter, Modal, Search
} from '../../../shared'
import { useAppDispatch, useAppSelector } from '../../../core/hooks'
import {
  getPartnerships,
  sendConnectionInvitation,
  suspendConnection,
  unsuspendConnection,
  cancelConnection,
  updateConnection,
  updateFilter, filterData
} from './insurance-partnership-slice'
import styles from "../styles.module.scss";
import {
  PARTNERSHIPS_STATUS_TEXTS,
  PARTNERSHIPS_PRIORITY_TEXTS, INSURANCE_PARTNERSHIPS
} from '../../../services/constants'
import { Autocomplete, Button } from '../../../ui-components'
import PartnershipStatusText from './partnership-status-text'
import { setData, toggleMainPanel} from '../../../app/app-slice'
import { CloseIcon } from '../../../assets'
import SocketContext from "../../../core/socket-context";
import {useHistory} from "react-router-dom";
import {INSURANCE_CONNECTION_STATUSES} from "../constants";

const InsurancePartnerships = () => {
  const dispatch = useAppDispatch()
  const socket = useContext(SocketContext);
  const {partnerships, filter} = useAppSelector(state => state.insurancePartnerships)

  const [selectedER, setSelectedER] = useState<any>({})
  const [suspendModalOpen, setSuspendModalOpen] = useState<boolean>(false)
  const [cancelModalOpen, setCancelModalOpen] = useState<boolean>(false)
  const [connectionUUID, setConnectionUUID] = useState<string>('')
  const [priority, setPriority] = useState<number>(0)

  const app = useAppSelector(state => state.app)
  const history = useHistory()
  useEffect(() => {
    dispatch(setData({prop: 'pageTitle', data: 'Сотрудничество'}))
    dispatch(getPartnerships())
  }, [dispatch, history.location])

  useEffect(() => {
    socket.on('connection', () => {
      dispatch(getPartnerships())
    })
  }, [socket])

  const setStatusText = (partner): ReactElement => {
    let statusText:any = ''
    switch (partner.status) {
      case 1:
        statusText = <PartnershipStatusText color={'#505D66'} text={PARTNERSHIPS_STATUS_TEXTS[partner.status - 1]}/>
        break
      case 2:
        statusText = <PartnershipStatusText color={'#192233'} text={PARTNERSHIPS_STATUS_TEXTS[partner.status - 1]}/>
        break
      case 3:
        statusText = <PartnershipStatusText color={'#192233'} text={PARTNERSHIPS_STATUS_TEXTS[partner.status - 1]}/>
        break
      case 4:
        statusText = <PartnershipStatusText color={'#192233'} text={PARTNERSHIPS_STATUS_TEXTS[partner.status - 1]}/>
        break
      default:
        statusText = <Button type='contained'>Отправить запрос</Button>
        break
    }
    return statusText
  }

  const setPanelFooterBtn = (connection) => {
    switch (connection.statusNumber) {
      case 1:
        return (<Fragment>
            <Button className={'mr-15'} type='contained' fullWidth onClick={() => cancelConnectionModel(connection.connection_uuid)}>Отменить запрос</Button>
            <Button className={'mr-15'} type='contained' fullWidth onClick={() => sendUpdateConnection(connection.connection_uuid)}>Обновить</Button>
          </Fragment>)
      case 2:
        return (<Fragment>
          <Button className={'mr-10'} type='contained' fullWidth onClick={() => suspendConnectionModel(connection.connection_uuid)}>Приостановить</Button>
          <Button className={'mr-15'} type='contained' fullWidth onClick={() => sendUpdateConnection(connection.connection_uuid)}>Обновить</Button>
          <Button className={'mr-10'} type='contained' fullWidth onClick={() => cancelConnectionModel(connection.connection_uuid)}>Отменить</Button>
        </Fragment>)
      case 3:
        return <Button className={'mr-15'} type='contained' fullWidth onClick={() => sendConnectionRequest(connection.uuid)}>Отправить запрос</Button>
      case 4:
        return (<Fragment>
          <Button className={'mr-15'} type='contained' fullWidth onClick={() => sendUnsuspendConnection(connection.connection_uuid)}>Возобновить</Button>
          <Button className={'mr-15'} type='contained' fullWidth onClick={() => sendUpdateConnection(connection.connection_uuid)}>Обновить</Button>
        </Fragment>)
      default:
        return (<Fragment>
          <Button className={'mr-15'} type='contained' fullWidth onClick={() => sendConnectionRequest(connection.uuid)}>Отправить запрос</Button>
        </Fragment>)
    }
  }

  const selectER = (er, index) => {
    er.statusNumber = statusArr[index].statusNumber
    er.uuid = statusArr[index].uuid
    er.connection_uuid = statusArr[index].connection_uuid
    setPriority(statusArr[index].priority)
    setSelectedER(er)
    dispatch(toggleMainPanel())
  }

  const sendConnectionRequest = (uuid: string) => {
    dispatch(sendConnectionInvitation({ emergency_uuid: uuid, priority }))
      .then(res => {
        if (res && res.connection_created) {
          dispatch(getPartnerships())
          dispatch(toggleMainPanel())
        }
        }
      )
      .catch(error => {
        console.log(error)
      })
  }

  const suspendConnectionModel = (uuid: string) => {
    setSuspendModalOpen(true)
    setConnectionUUID(uuid)
  }

  const cancelConnectionModel = (uuid: string) => {
    setCancelModalOpen(true)
    setConnectionUUID(uuid)
  }

  const sendSuspendConnection = async () => {
    await dispatch(suspendConnection(connectionUUID))
    setSuspendModalOpen(false)
    dispatch(getPartnerships())
    dispatch(toggleMainPanel())
  }

  const sendUnsuspendConnection = (uuid: string) => {
    dispatch(unsuspendConnection(uuid))
      .then(res => {
          if (res) {
            dispatch(getPartnerships())
            dispatch(toggleMainPanel())
          }
        }
      )
      .catch(error => {
        console.log(error)
      })
  }

  const sendCancelConnection = async () => {
    await dispatch(cancelConnection(connectionUUID))
    setCancelModalOpen(false)
    dispatch(getPartnerships())
    dispatch(toggleMainPanel())
  }

  const sendUpdateConnection = (uuid: string) => {
    dispatch(updateConnection({ uuid, priority }))
      .then(res => {
        if (res && res.updated) {
          setPriority(0)
          dispatch(getPartnerships())
          dispatch(toggleMainPanel())
        }
      })
  }

  const filtered = [] as any
  const statusArr = [] as any
  for (let partner of partnerships) {
    if(partner.visible) {
      filtered.push({
        name: partner.name,
        address: partner.address,
        phone: partner.phone,
        email: partner.email,
        priority: partner.priority ? PARTNERSHIPS_PRIORITY_TEXTS[partner.priority - 1].type : 'Средный',
        status: setStatusText(partner),
      })
    }
    statusArr.push({
      statusNumber: partner.status,
      connection_uuid: partner.connection_uuid,
      uuid: partner.uuid,
      priority: partner.priority ? partner.priority : 2,
    })
  }

  const bodyRow = filtered.map((el, i) => Object.values(el))
  return (
    <div id={'partnerships'}>
      <div className={styles.filterHeader}>
        <Search value={filter.name as string} placeholder={'Поиск'} handleChange={(e) => {
          dispatch(updateFilter('name', e.target.value))
            .then(() => dispatch(filterData()))
        }}/>
        <div className='d-flex'>
          <Autocomplete label='Приоритет'
                        isClearable
                        onChange={(data) => {
                          dispatch(updateFilter('priority', data.key))
                            .then(() => dispatch(filterData()))
                        }}
                        value={filter.priority}
                        className={`${styles.selectWrapper} mr-20`}
                        options={PARTNERSHIPS_PRIORITY_TEXTS}
                        optionLabel={'type'} optionValue={'key'}/>
          <Autocomplete label='Статус'
                        isClearable
                        onChange={(data) => {
                          dispatch(updateFilter('status', data.key))
                            .then(() => dispatch(filterData()))
                        }}
                        value={filter.status}
                        className={styles.selectWrapper}
                        options={INSURANCE_CONNECTION_STATUSES}
                        optionLabel={'value'} optionValue={'key'}/>
        </div>

      </div>
        <Table className={'left-table-container'}>
          <div className={'left-table-container fit-to-screen'}>
            <TableHead>
              {INSURANCE_PARTNERSHIPS.map((el, i) => <div className={`item`} key={i}>{el}</div>)}
            </TableHead>
            <TableBody>
              {filtered.map((el, i) =>
                <div key={i} className='row'>
                  {
                    bodyRow[i].map((el, index) =>
                      <div key={index} className={`item`} onClick={() => selectER(filtered[i], i)}>
                    <span title={el}>
                      {el}
                    </span>
                      </div>)
                  }
                </div>
              )}
            </TableBody>
          </div>
        </Table>
        <Panel handleClose={() => dispatch(toggleMainPanel())} open={app.mainPanelOpen}>
          <PanelHeader>
            <div id='header'>
              <div className={`request-info ${styles.requestInfo}`}>
                <div className={`title-wrapper ${styles.titleWrapper}`}>
                  <div className="status-wrapper">
                    <p className={`${styles.title}`}>СМП</p>
                  </div>
                  <div className="actions">
                    <CloseIcon onClick={() => dispatch(toggleMainPanel())}/>
                  </div>
                </div>
              </div>
            </div>
          </PanelHeader>
          <div id={`${styles.insurancePartnershipCard}`} className={`request-info-container`}>
            <p className={`title ${styles.orgName}`}>{selectedER.name}</p>
            <div className={`mt-40 mb-20 ${styles.wrapper}`}>
              <Autocomplete className={styles.input}
                            options={PARTNERSHIPS_PRIORITY_TEXTS}
                            value={priority}
                            label={'Приоритет'}
                            onChange={(data) => setPriority(data.key)}
                            optionLabel={'type'} optionValue={'key'}/>
            </div>
            <InfoText className='mb-20' title='Адрес' text={selectedER.address}/>
            <div className='wrapper flex-row d-flex space-between mb-40'>
              <InfoText title='Телефон' text={selectedER.phone}/>
              <InfoText title='Почта' text={selectedER.email}/>
            </div>
          </div>
          <PanelFooter className='d-flex space-between'>
            {setPanelFooterBtn(selectedER)}
            <Button type='outlined' fullWidth onClick={() => dispatch(toggleMainPanel())}>Закрыть</Button>
          </PanelFooter>
        </Panel>
      <Modal open={suspendModalOpen}
             closeIcon
             title={'Приостановка сотрудничество'}
             handleClose={() => {
               setSuspendModalOpen(false)
             }}>
        <p className="modalText mb-50">Вы уверены, что хотите приостановить сотрудничество?</p>
        <div className='d-flex space-between'>
          <Button type='contained'
                  fullWidth
                  onClick={sendSuspendConnection}>Да</Button>
          <Button className={`ml-30`}
                  fullWidth
                  type='outlined'
                  onClick={() => setSuspendModalOpen(false)}>Нет</Button>
        </div>
      </Modal>
      <Modal open={cancelModalOpen}
             closeIcon
             title={'Отменить сотрудничество'}
             handleClose={() => {
               setCancelModalOpen(false)
             }}>
        <p className="modalText mb-50">Вы уверены, что хотите отменить сотрудничество?</p>
        <div className='d-flex space-between'>
          <Button type='contained'
                  fullWidth
                  onClick={sendCancelConnection}>Да</Button>
          <Button className={`ml-30`}
                  fullWidth
                  type='outlined'
                  onClick={() => setCancelModalOpen(false)}>Нет</Button>
        </div>
      </Modal>
    </div>
  )
}

export default InsurancePartnerships
